'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _es6Error = require('es6-error');

var _es6Error2 = _interopRequireDefault(_es6Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when an error is encountered with an HTTP request.
 * @extends {ExtendableError}
 */
var RequestError = function (_ExtendableError) {
  _inherits(RequestError, _ExtendableError);

  /**
   * Constructor.
   * @param {Response} [response=null] - A fetch response object.
   */
  function RequestError() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, RequestError);

    var _this = _possibleConstructorReturn(this, (RequestError.__proto__ || Object.getPrototypeOf(RequestError)).call(this, response ? 'Encountered HTTP ' + response.status + ': ' + response.statusText + '.' : 'Encountered an error while performing a request.'));

    _this.response = response;
    return _this;
  }

  return RequestError;
}(_es6Error2.default);

exports.default = RequestError;


//////////////////
// WEBPACK FOOTER
// ./src/v2/errors/RequestError.js
// module id = 1708
// module chunks = 0